// 转化为友好时间
Date.prototype.friendTime = function(){
    const time = this.getTime()
    const nowTime = new Date().getTime()
    const y = this.getFullYear()
    const m = this.getMonth() + 1
    const d = this.getDate()
    const hh = this.getHours()
    const mm = this.getMinutes()
    const ss = this.getSeconds()
    const diff = nowTime - time
    let result = ''
    if(diff<1000*60){
        result = '刚刚'
    }else if(diff<1000*60*60){
        result = parseInt(diff / (1000*60)) + "分钟前";
    }else if(diff<1000*60*60*24){
        result = parseInt(diff / (1000*60*60)) + "小时前";
    }else if(diff<1000*60*60*24*2){
        result = '昨天';
    }else if(diff<1000*60*60*24*3){
        result = '前天';
    }else if(m == new Date().getMonth() + 1 && y == new Date().getFullYear()){
        result = `${d}日${hh}时${mm}分`;
    }else if(y == new Date().getFullYear()){
        result = `${m}月${d}日${hh}时${mm}分`;
    }else{
        result = `${y}年${m}月${d}日${hh}时${mm}分`
    }
    return result
}

//年
Date.prototype.getDatatime2 = function(){
    const y = this.getFullYear()
    return `${y}`
}

//月
Date.prototype.getDatatime4 = function(){
    const m = this.getMonth() + 1
    return `${m}`
}

//年月日
Date.prototype.getDatatime1 = function(){
    const y = this.getFullYear()
    let m = this.getMonth() + 1
    let d = this.getDate()
    if(m<10){
        m=`0${m}`
    }
    if(d<10){
        d=`0${d}`
    }
    return `${y}-${m}-${d}`
}

//年月日格式
Date.prototype.getDatatime3 = function(){
    const y = this.getFullYear()
    let m = this.getMonth() + 1
    let d = this.getDate()
    if(m<10){
        m=`0${m}`
    }
    if(d<10){
        d=`0${d}`
    }
    return `${y}年${m}月${d}日`
}

//年月日时分秒
Date.prototype.getDatatime = function(){
    const y = this.getFullYear()
    const m = this.getMonth() + 1
    const d = this.getDate()
    let hh = this.getHours()
    let mm = this.getMinutes()
    const ss = this.getSeconds()
    if(hh<10){
        hh=`0${hh}`
    }
    if(mm<10){
        mm=`0${mm}`
    }
    return `${y}-${m}-${d}-${hh}:${mm}:${ss}`
}